import React, { useContext, useEffect, useState } from "react";
import { Toolbar } from "@fluentui/react-components";
import "../css/CommonToolBar.css";
import { CommonToolbarProps } from "../types/CommonTypes";
import { DropDownNavigation } from "./DropDownNavigation";
import { Constants } from "../common/constants";
import LoginToolbar from "./LoginToolbar";
import { TeamsFxContext } from "@siemensplm/common_utils";

const CommonToolbar: React.FC<CommonToolbarProps> = ({
  capabilitiesList,
  activeCapability,
  onSelect,
}) => {
  const teamsContext = useContext(TeamsFxContext);

  const isHandheldDevice =
    teamsContext?.clientType === Constants.androidClientType ||
    teamsContext?.clientType === Constants.iosClientType ||
    teamsContext?.clientType === Constants.teamsPhonesClientType ||
    teamsContext?.clientType === Constants.teamsRoomsAndroidClientType;
  const useThickToolbar =
    isHandheldDevice && activeCapability?.mobileToolbarComponentRow2
      ? true
      : false;

  return (
    <div
      className={
        useThickToolbar
          ? "common-toolbar-rootcontainer-thick"
          : "common-toolbar-rootcontainer"
      }
    >
      <Toolbar aria-label="Common Toolbar" className="common-toolbar-container">
        <div className="common-toolbar-left-section">
          <div
            className={`common-toolbar-dropdown-wrapper${isHandheldDevice ? " mobile-dropdown" : ""}`}
          >
            {/* This width is to make sure, image alignment is correct with App image */}
            <div style={{ width: "10px" }} />
            <DropDownNavigation
              capabilitiesList={capabilitiesList}
              onSelect={onSelect}
              activeCapability={activeCapability}
            />
          </div>
        </div>
        <div className="common-toolbar-right-section">
          {!useThickToolbar &&
            activeCapability &&
            activeCapability.toolbarComponent && (
              <activeCapability.toolbarComponent />
            )}
          {isHandheldDevice &&
            activeCapability &&
            activeCapability.mobileToolbarComponentRow1 && (
              <activeCapability.mobileToolbarComponentRow1 />
            )}
        </div>
        <div className="common-toolbar-logout">
          <LoginToolbar />
        </div>
      </Toolbar>
      {isHandheldDevice && (
        <div className="common-toolbar-bottom-section">
          {activeCapability && activeCapability.mobileToolbarComponentRow2 && (
            <activeCapability.mobileToolbarComponentRow2 />
          )}
        </div>
      )}
    </div>
  );
};

export default CommonToolbar;
